<template>
    <div class="memoryblock-container">
      <div class="main-box page-content-box">
        <BlockTitle
          title="宣传纪念"
          channelAlias="xuanchuan"></BlockTitle>

        <Quotation 
          class="quotation"         
         :content="quotationContent"></Quotation>

        <div v-if="swiperMode == false" class="article-blocks-container">
          <ArticleBlock v-for="item in blockList.slice(0, 3)"
            :key="item.blockId"
            :blockItem="item"
            class="article-block-box">
            </ArticleBlock>
        </div>
        <div v-else class="article-swiper-container">
          <swiper class="article-swiper" ref="swiper" :options="swiperOption">
            <swiper-slide
              :style="{'width':blockWidth}"
              class="article-slide text-select-disable"
              v-for="item in blockList.slice(0, 3)"
              :key="item.blockId">
              <ArticleBlock :blockItem="item"></ArticleBlock>
            </swiper-slide>        
          </swiper>
        </div>

        <BooksBlock style="width:100%;"
          class="books-block"
          :blockItem="blockList[3]"></BooksBlock>

        <RewardsBlock
          class="rewards-block"
         style="width: 100%"></RewardsBlock>

      </div>
    </div>
</template>
<script>
  import BlockTitle from "@/components/blocks/blocktitle";
  import Quotation from "@/components/blocks/quotation";
  import ArticleBlock from "./articleblock.vue";
  import BooksBlock from "./booksblock.vue";
  import RewardsBlock from "./rewardsblock.vue";
  import * as channelConfig from "@/config/channels";
  import "swiper/dist/css/swiper.css";
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

    export default{
        components: {BlockTitle, Quotation, ArticleBlock, BooksBlock, RewardsBlock, swiper, swiperSlide},
        props:{},
        data(){
            return {
              quotationContent: "“伏枥老骥”最好用“扶植新秀，甘做人梯”的精神实现自己“志在千里”的雄心壮志。 今后衡量我贡献大小的一个重要标志，就是发现了多少年轻才骏。",

              blockList:[
                {
                  id: 1,
                  name: '追思缅怀',
                  alias: channelConfig.blockAlias.BLOCK_ALIAS_ZHUISIMIANHUAI,
                },
                {
                  id: 2,
                  name: '回忆综述',
                  alias: channelConfig.blockAlias.BLOCK_ALIAS_HUIYIZONGSHU,
                },
                {
                  id: 3,
                  name: '事迹报告',
                  alias: channelConfig.blockAlias.BLOCK_ALIAS_BAOGAOZONGSHU,
                },
                {
                  id: 4,
                  name: '研究出版',
                  alias: channelConfig.blockAlias.BLOCK_ALIAS_YANJIUCHUBAN,
                },
              ],
              swiperMode: false,
              swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 0,
                direction: 'horizontal',
                freeMode: true,              
              },
              blockWidth: '33.33%',
            };
        },
        methods:{          
          onResize(){
            let screenW = document.documentElement.clientWidth;
            if(screenW < 700){
              this.blockWidth = '280px';
              this.swiperMode = true;
            }else
            {
              this.blockWidth = '33.33%';
              this.swiperMode = false;
            }
          }
        },
        created(){
          window.addEventListener('resize', this.onResize);
        },
        destroyed(){
          window.removeEventListener('resize', this.onResize);
        },
        mounted(){
          this.$nextTick(()=>{
              this.onResize();
          });
        },
    };
</script>
<style scoped>
.memoryblock-container{
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  padding: 60px 0px 60px 0px;
  background: #D8DCE2;
}
 .main-box{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  /*gap: 30px;*/
 }
 .quotation{
  margin-top: 30px;
 }

.article-blocks-container{
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  padding: 0px;
  box-sizing: border-box;
    /*gap: 30px;*/
  
  margin-top: 30px;
}
.article-block-box{
  margin-left: 15px;
  margin-right: 15px;
}
.article-block-box:first-child{
  margin-left: 0px;
}
.article-block-box:last-child{
  margin-right: 0px;
}

.article-swiper-container{
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  margin-top: 30px;
}

.article-swiper{
  width: 100%;
}
.article-slide{
  width: 300px;
  height: 100%;
  cursor: pointer;
}
.books-block{
  margin-top: 30px;
  box-sizing: border-box;
}
.rewards-block{
  margin-top: 30px;
}


@media screen and (max-width: 1000px){
  .memoryblock-container{
    padding: 24px 0 12px 0;
  }
  /*
  .main-box{
    gap: 20px;
  }
  */
  .quotation{
    margin-top: 20px;
  }
  .article-blocks-container{
    /*gap: 10px;*/
    margin-top: 20px; 
  }  
  .article-block-box{
    margin-left: 5px;
    margin-right: 5px;
  }

  .article-swiper-container{
    margin-top: 20px;
  }
  .books-block{
    margin-top: 20px;
  }
  .rewards-block{
    margin-top: 20px;
  }

}

@media screen and (max-width: 600px){
  /*
  .main-box{
    gap: 12px;
  }  
  */
  
  .quotation{
    margin-top: 12px;
  }
  .article-blocks-container{    
    margin-top: 12px; 
  }  
  .article-swiper-container{
    margin-top: 12px;
    padding: 0 0 0 10px;
  }
  .books-block{
    margin-top: 12px;
  }
  .rewards-block{
    margin-top: 12px;
  }  
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/memoryblock/index.vue